import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "flex flex-wrap items-start gap-y-4 px-4" }
const _hoisted_3 = { class: "mt-1.5" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "pr-6" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Title, {
      class: "px-4",
      label: "Kriteria Booking"
    }),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_DataWrapper, {
        label: "ID Config.",
        class: "w-6/12",
        value: _ctx.detailData.commissionId
      }, null, 8, ["value"]),
      _createVNode(_component_DataWrapper, {
        label: "Kode",
        class: "w-6/12",
        value: _ctx.detailData.commissionCode
      }, null, 8, ["value"]),
      _createVNode(_component_DataWrapper, {
        label: "Sumber Booking",
        class: "w-6/12",
        value: _ctx.commissionBookingSource
      }, null, 8, ["value"]),
      _createVNode(_component_DataWrapper, {
        label: "Komisi Untuk",
        class: "w-6/12",
        value: _ctx.commissionFor
      }, null, 8, ["value"]),
      _createVNode(_component_DataWrapper, {
        label: "Shipment ID",
        class: "w-full"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode("div", _hoisted_3, null, 512), [
            [_directive_sanitize_html, _ctx.commissionShipmentId]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, {
        label: "Kota Asal",
        class: "w-6/12",
        value: _ctx.detailData.commissionOriginCity?.name
      }, null, 8, ["value"]),
      _createVNode(_component_DataWrapper, {
        label: "Kota Tujuan",
        class: "w-6/12",
        value: _ctx.detailData.commissionDestinationCity?.name
      }, null, 8, ["value"]),
      _createVNode(_component_DataWrapper, {
        label: "Produk",
        class: "w-6/12",
        value: _ctx.detailData.commissionProduct?.name
      }, null, 8, ["value"]),
      _createVNode(_component_DataWrapper, {
        label: "Komoditas",
        class: "w-6/12",
        value: _ctx.detailData.commissionCommodity?.name
      }, null, 8, ["value"])
    ]),
    _hoisted_4
  ]))
}